import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  TITLE = 'Fusion';
  USERNAME_HT = 'Please enter your username';
  PASSWORD_HT = 'Please enter your password';
  ERR_MSG = 'Oops! Something went wrong.';
  SHORT_ERR = 'Too short';
  LONG_ERR = 'Too long';

  HTTP_ERRORS = {
    400: 'Session count exceeded.',
    401: 'Wrong credentials. Try again.',
    403: 'Wrong credentials. Try again.',
    404: 'Does not exist.',
    406: 'Your account has been disabled. Please contact your group administrator.',
    409: 'User with this email already exists.',
    500: 'Server internal error.'
  };
}
